import { render, staticRenderFns } from "./SendAudioIcon.vue?vue&type=template&id=34269f60"
import script from "./SendAudioIcon.vue?vue&type=script&lang=js"
export * from "./SendAudioIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports